import { PATHS } from 'src/common/constants';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import Loader from '../../components/Loader';
import Overlay from '../../components/Overlay';
import PropertyWalkThroughForm from '../../components/PropertyWalkThroughForm';
import MoreDetails from './MoreDetails/MoreDetails';
import { Headline } from './header/header';
import SuiteTabs from 'src/pages/Suite/Bottom/SuiteTabs';
import SuiteActions from 'src/pages/Suite/Actions/Actions';
import SuiteBreadcrumb from 'src/pages/Suite/Breadcrumb/Breadcrumb';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import {
  Property,
  Suite as SuiteType,
} from 'src/SharedCustomHooks/UseSuiteActions/types';
import {
  useSuitePageOrchestrator,
  UseSuitePageOrchestratorReturn,
} from 'src/pages/Suite/CustomHooks/UseSuitePageOrchestrator/useSuitePageOrchestrator';

interface SuiteProps {
  match: {
    params: {
      id: string;
    };
  };
  location: {
    state?: {
      data?: {
        serviceRequestId?: string;
      };
      property?: Property;
      suite?: SuiteType;
      activeTab?: number;
      from?: string;
      onNavigationBack?: boolean;
    };
  };
  history: any;
}

const Suite = ({ match, location, history }: SuiteProps) => {
  const {
    loadingSuite,
    error,
    isLoading,

    suite,
    counts,
    walkThroughs,
    properties,
    property,
    propertyManagerDetails,
    allowedTabList,
    moreDetails,
    notesAPI,

    showOverlay,
    isEventShow,

    propertyWalkThroughFormIsVisible,

    user,
    userRole,
    branding,
    serviceRequestId,
    suiteIdParts,
    showHomeownerDashboardNavigation,
    isFromDashboard,

    noteVisibleToHomeownerOccupantRealtor,
    isHomeOwnerCheckUserResult,
    isHomeOwnerOccupantUserResult,
    activeTabIndex,
    suiteDetailsComponents,
    showMissingPrimaryHomeownerCallout,
    showSuiteActions,

    onSaveSuite,
    onDeleteUnit,
    onReRenderKeyPickupPdf,
    onToggleMobileSync,
    onFetchDetails,
    onEditSuite,
    onCloseOverlay,
    onCloseMoreDetails,

    fetchSuiteData,
    refreshSuiteCounts,
  }: UseSuitePageOrchestratorReturn = useSuitePageOrchestrator({
    match,
    location,
    history,
  });

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            Error Loading Suite
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <WithNavigation
        title={suite?.number || 'Suite'}
        top={
          <HeadingWithDetails
            style={{
              backgroundImage: 'url(/assets/banner-property.png)',
            }}
            breadcrumb={
              <SuiteBreadcrumb
                serviceRequestId={serviceRequestId}
                isFromDashboard={isFromDashboard}
                userRole={userRole}
                currentLocation={location}
                showHomeownerDashboardNavigation={
                  showHomeownerDashboardNavigation
                }
                suiteIdParts={suiteIdParts}
                property={property}
                loading={loadingSuite}
              />
            }
            headline={
              <Headline
                loading={loadingSuite}
                suiteName={suite?.number || ''}
                isCommonArea={suite?.isCommonArea}
                showProfile={suite?.primaryContact}
                name={
                  suite?.primaryContact?.firstname +
                  ' ' +
                  suite?.primaryContact?.lastname
                }
                disableLink={!suite?.primaryContact?.id}
                profileLinkTo={{
                  pathname: PATHS.CONTACTS_VIEW.replace(
                    ':id',
                    suite?.primaryContact?.id
                  ),
                  state: { isFromDashBoard: isFromDashboard },
                }}
                phone={suite?.primaryContact?.phone}
                image={undefined}
                showMissingPrimaryCallout={showMissingPrimaryHomeownerCallout}
              />
            }
            items={suiteDetailsComponents}
            actions={
              !loadingSuite &&
              showSuiteActions && (
                <SuiteActions
                  isHomeOwnerCheckUser={isHomeOwnerCheckUserResult}
                  suite={suite}
                  user={user}
                  onToggleMobileSync={onToggleMobileSync}
                  onReRenderKeyPickupPdf={onReRenderKeyPickupPdf}
                  onFetchDetails={onFetchDetails}
                  onEditSuite={onEditSuite}
                  onDeleteUnit={onDeleteUnit}
                  showOverlay={showOverlay}
                  onCloseOverlay={onCloseOverlay}
                  onSaveSuite={onSaveSuite}
                />
              )
            }
          />
        }
        bottom={
          <>
            <SuiteTabs
              walkThroughs={walkThroughs}
              userRole={userRole}
              activeTabIndex={activeTabIndex}
              isHomeOwnerOccupantUser={isHomeOwnerOccupantUserResult}
              suite={suite}
              property={property}
              propertyManagerDetails={propertyManagerDetails}
              history={history}
              counts={counts}
              branding={branding}
              match={match}
              isEventShow={isEventShow}
              noteVisibleToHomeownerOccupantRealtor={
                noteVisibleToHomeownerOccupantRealtor
              }
              notesAPI={notesAPI}
              onFetchSuiteData={() => fetchSuiteData()}
              refreshSuiteCounts={refreshSuiteCounts}
              properties={properties}
              allowedTabList={allowedTabList}
              loading={loadingSuite}
            />
            <Overlay
              showOverlay={propertyWalkThroughFormIsVisible}
              content={<PropertyWalkThroughForm />}
            />
            {!loadingSuite && isLoading && <Loader center={true} />}
            {moreDetails && (
              <MoreDetails
                closePopup={onCloseMoreDetails}
                details={moreDetails}
              />
            )}
          </>
        }
      />
    </div>
  );
};

export default Suite;
